import { NextSeo } from 'next-seo'
import React, { ReactElement } from 'react'
import { CourseConfigType } from 'common/src/courseConfig'
import { getSiteOriginForCourseConfigType } from '@/components/NextSeo/seoConfig'

interface PageSeoProps {
    title: string
    description: string
    // Path this page canonically lives at, e.g. '/eupheus'. Every page needs a
    // canonical because both the apex and www hosts serve the site.
    canonicalPath: string
    courseConfigType?: CourseConfigType
}

/**
 * Per-page title / description / canonical. Site-wide defaults (og:, twitter:,
 * fallback title + description) come from the DefaultSeo in _app.
 */
export const PageSeo: React.FC<PageSeoProps> = (props): ReactElement => {
    const origin = getSiteOriginForCourseConfigType(
        props.courseConfigType ?? CourseConfigType.fsaHealth
    )
    return (
        <NextSeo
            title={props.title}
            description={props.description}
            canonical={`${origin}${props.canonicalPath}`}
            openGraph={{
                title: props.title,
                description: props.description,
                url: `${origin}${props.canonicalPath}`,
            }}
        />
    )
}
